// CRM metadata for the mapping editor (properties, pipelines, owners, object types). Schemas in api-crm-metadata.ts.
import { CrmMetadataQuerySchema, CrmMetadataSchema } from './api-crm-metadata.js';
import { IdParam, route, W } from './route-def.js';

export const crmMetadataRoutes = {
  getCrmMetadata: route({
    method: 'GET', path: '/workspaces/:workspaceId/crm/connections/:connectionId/metadata', summary: 'Campos, pipelines, responsables y tipos de registro del CRM para el mapeo (lectura en vivo, caché corta)', tag: 'crm',
    minRole: 'admin', params: W({ connectionId: IdParam }), query: CrmMetadataQuerySchema, response: CrmMetadataSchema,
  }),
} as const;
